import { Component, OnInit, OnDestroy, Input, ViewChild, ElementRef, ChangeDetectorRef } from '@angular/core';
import { Features, OptionMenu } from '@app/layout/utilities/models/layout-model';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../utilities/services/api.service';
import { BaseService } from '@app/system/services/base.service';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { PopupComponent } from '@app/components/popup/popup.component';
import { LocaleService } from '@app/system/services/locale.service';
import { DetectDeviceService } from '@app/system/services/detect-device.service';
import { AssignmentUpdateComponent } from '@app/modules/assignment/assignment-update/assignment-update.component';
import { CommonView } from '@app/components/utilities/models/common-view-model';
import { ResourceFormsComponent } from '../resource-forms/resource-forms.component';
import { PlaylistFormsComponent } from '@app/modules/playlist/playlist-forms/playlist-forms.component';
import { GlobalFunctionService } from '@app/system/services/global-function.service';
import { AppInitializerService } from '@app/app-initializer.service';
import { TrackingEmit } from '@app/components/video-player/video-player.component';
import { ContentImageCard } from '@app/components/widget/content-image-card/content-image-card.component';
import { QuestionsFormsComponent } from '../../questions/questions-forms/questions-forms.component';
import { LineChartModel, LineOptionsModel } from '@app/components/charts/line-chart/line-chart.component';
import { HandleBarPipe } from '@app/system/pipes/handle-bar/handle-bar.pipe';
import { ApiService as WorkgroupApiService } from '@app/modules/workgroup/utilities/services/api.service';
import { EventCard } from '@app/components/widget/event-card/event-card.component';
import { PlaylistCard } from '@app/components/widget/playlist-card/playlist-card.component';
import { QuestionCard } from '@app/components/widget/question-card/question-card.component';
import { InternalEventFormsComponent } from '@app/modules/internal-event/internal-event-forms/internal-event-forms.component';
import { CourseFormsComponent } from '@app/modules/course/course-forms/course-forms.component';
import { ApiService as ExternalEventApiService } from '@app/modules/external-event/utilities/services/api.service';
import { ApiService as InternalEventApiService } from '@app/modules/internal-event/utilities/services/api.service';
import { ApiService as MOOCApiService } from '@app/modules/mooc/utilities/services/api.service';

@Component({
	selector: 'app-resource-detail',
	templateUrl: './resource-detail.component.html',
	styleUrls: ['./resource-detail.component.scss']
})
export class ResourceDetailComponent implements OnInit, OnDestroy {

	@Input() actualResourceID;
	@Input() type = '';
	@ViewChild('objectData') set checkSupport(content: ElementRef) {
		if (content) {
			const el: HTMLElement = content.nativeElement;
			el.addEventListener('load', this.isDocumentLoaded.bind(this));
		}
	}

	features: Features = {};
	resourceLoader = true;
	assignmentLoader = true;
	featureLoader = true;
	playlistLoader = true;
	resourceDetail;
	assignmentDetail: any = {
		status: { key: '' }
	};
	currentUser;
	subscriptions: any = [];
	dialogCloseData;
	popupRef;
	noData = false;
	resourceID;
	reloadAssignment = false;
	headerType: 'playlist' = null;
	actionBtns = { prevBtn: false, nextBtn: false };
	actionType;
	playlistData = [];
	assignmentID;
	documentLoaded = false;
	conversationType = 'answer'
	authorData;
	publishButtonDisable = false;
	actionFrom = '';
	optionMenu: Array<OptionMenu> = [];
	segment: number;
	readSegmentLog = true;
	canStartPlay = false;
	trackingEmit: Array<TrackingEmit> = [];
	timeLogInterval;
	readTimeLog = true;
	CCVAdditionalData: any = {};
	deviceDetails;
	playlistParentData;
	closeQuestion = false;
	processed = false;
	selectedPlaylistQueueIndex = 0;
	youTubeTimeInterval;
	YTPlayer;
	YTStatus = false;
	YTIntervalCleared = false;
	YTPlayerReached = false;
	timeProcessed = false;
	height: number = 176;
	intervalCleared = false;
	permissionError = false;
	youtubeLoader = false;
	addScrollClassToPopup = true;
	clearInterval;
	totalYoutubeSegments = 0;
	youtTubeSegmentData = [];
	youtTubeSegmentedData = [];
	oldYouTubeSegmentIndex;
	patchMessage;
	skillMPermission = false;

	constructor(
		private popup: MatDialog,
		public gfService: GlobalFunctionService,
		private activatedRoute: ActivatedRoute,
		public locale: LocaleService,
		private apiService: ApiService,
		private baseService: BaseService,
		public detectDevice: DetectDeviceService,
		private externalEventApiService: ExternalEventApiService,
		private internalEventApiService: InternalEventApiService,
		private moocApiService: MOOCApiService,
		private cdref: ChangeDetectorRef,
		private appInit: AppInitializerService,
		private workgroupApiService: WorkgroupApiService
	) {
		this.baseService.resourcePopupTriggered = true;
		this.currentUser = this.gfService.sessionUser;
	}

	ngOnInit(): void {
		this.deviceDetails = this.detectDevice.fingerPrint;
		this.subscriptions.push(
			this.detectDevice.resolutionState$.subscribe((resp) => {
				if (resp.xl) {
					this.height = 370;
				} else if (resp.lg) {
					this.height = 270;
				} else {
					this.height = 176;
				}
			})
		);
		if (this.actualResourceID) {
			this.resourceLoader = true;
			this.assignmentLoader = true;
			this.resourceID = this.actualResourceID;
			if (this.resourceID) {
				this.getDetail();
			}
		} else {
			this.subscriptions.push(
				this.activatedRoute.queryParamMap.subscribe((params) => {
					this.resourceLoader = true;
					this.assignmentLoader = true;
					if (params.get('assignmentID')) {
						this.assignmentID = Number(params.get('assignmentID'));
					}
					this.resourceID = Number(params.get('resourceID'));
					if (this.resourceID) {
						this.getDetail();
					}
				})
			);
		}
		this.trackingEmit.push({
			eventType: 'a',
			time: '00:00:05'
		},
			{
				eventType: 'a',
				time: '00:00:10'
			},
			{
				eventType: 'a',
				time: '00:00:14'
			},
			{
				eventType: 'a',
				time: '00:00:20'
			},
			{
				eventType: 'a',
				time: '00:00:25'
			})

		if (this.baseService.checkModuleAccess('M13')) {
			this.skillMPermission = true;
		}
	}

	timeEmit(data) {
		console.log(data.time, data, 'emited')
	}

	searchPeopleDetail(data) {
		if (data && data.userID) {
			this.baseService.userDetail(data.userID);
		}
	}

	isDocumentLoaded(event) {
		this.documentLoaded = true;
	}

	fullScreen(element) {
		if (navigator.onLine) {
			if (element.requestFullscreen) {
				element.requestFullscreen();
			} else if (element.mozRequestFullScreen) {
				/* Firefox */
				element.mozRequestFullScreen();
			} else if (element.webkitRequestFullscreen) {
				/* Chrome, Safari and Opera */
				element.webkitRequestFullscreen();
			} else if (element.msRequestFullscreen) {
				/* IE/Edge */
				element.msRequestFullscreen();
			}
		}
	}

	getDetail(resourceUpdated: boolean = false) {
		
		this.CCVAdditionalData = {};
		this.permissionError = false;
		this.patchMessage = null;
		this.processed = false;
		const headers = {
			lanCode: sessionStorage.getItem('locale') || 'en'
		};
		this.subscriptions.push(
			this.apiService
				.detail(Number(this.resourceID), headers)
				.subscribe(
					(response) => {
						if (response) {
							this.dataBuild(response);
							this.resourceDetail = response;
							if (this.resourceDetail.resourceAction && this.popupRef && this.popupRef.componentInstance) {
								this.popupRef.componentInstance.dialogCloseData = {
									resourceStatus: this.resourceDetail.status,
									updated: resourceUpdated
								};
							}
							if (this.resourceDetail.infoFields && Object.keys(this.resourceDetail.infoFields).length && this.resourceDetail.resourceTypeID) {
								if (!['knowledgecard', 'playlist'].includes(this.resourceDetail.resourceTypeID.key)) {
									const headers = {
										lanCode: sessionStorage.getItem('locale') || 'en'
									};
									this.resourceLoader = true;
									this.apiService
										.getResource(this.resourceDetail.resourceTypeID.value, headers)
										.subscribe(
											(fieldResponse) => {
												if (fieldResponse && fieldResponse.length) {
													this.resourceDetail.infoData = [];
													for (const field of fieldResponse) {
														if (field.fieldType === 'textBox') {
															if (this.resourceDetail.infoFields[field.fieldColumn]) {
																const data: CommonView = {
																	label: field.fieldCaption,
																	value: this.resourceDetail.infoFields[field.fieldColumn],
																	type: 'text'
																};
																this.resourceDetail.infoData.push(data);
															}
														}
													}

												} else {
													// this.submitDisable = true;
												}
											},
											(error) => {
												this.gfService.errorHandler(error, {
													snackBar: {
														position: 'before'
													}
												});
											}
										)
										.add(() => {
											this.resourceLoader = false;
											this.playlistLoader = false;
										});
								}
							}
							this.featureLoader = false;
							this.noData = false;
						} else {
							this.noData = true;
							this.patchMessage = 'oops_this_resource_is_no_longer_available';
							// this.gfService.openSnackBar('ERROR', {
							// 	message: this.locale.translate('no_data_found'),
							// 	icon: 'clear',
							// 	position: 'before'
							// });
						}
					},
					(error) => {
						if (error.error.hasOwnProperty('errorCode')) {
							
							if (error.error.errorCode === 'PERMISSION_DENIED') {
								this.patchMessage = 'you_dont_have_permission_to_access_this_resource';
							} else if (error.error.errorCode === 'NOT_PUBLISHED') {
								this.patchMessage = 'oops_this_resource_has_been_unpublished';
							} else if (error.error.errorCode === 'RECORD_NOT_FOUND') {
								this.patchMessage = 'oops_this_resource_has_been_deleted';
							}
							this.permissionError = true;
							// this.featureLoader = false;
							this.resourceLoader = false;
							this.playlistLoader = false;
							if (this.popupRef && this.popupRef.componentInstance) {
								this.popupRef.componentInstance.popupLoader = false;
							}
						}
						
						if (!this.permissionError) {
							this.gfService.errorHandler(error, {
								snackBar: {
									position: 'before'
								}
							});
						}
					}
				)
				.add(() => {
					if (!this.permissionError) {
						this.getReadStatus();
						// if (this.resourceDetail.status.key === 'moderation') {
						// 	this.patchMessage = 'this_content_has_not_been_published';
						// }
					}
				})
		);
	}

	getReadStatus() {
		const headers: any = {
			lanCode: sessionStorage.getItem('locale') || 'en'
		};
		this.apiService.getResourceReadStatus(this.resourceID, headers).subscribe(
			(response) => {
				if (response) {
					if (this.resourceDetail) {
						this.resourceDetail.read = response.read;
						this.resourceDetail.lastTimeline = response.lastTimeline;
						this.resourceDetail.completedPercent = response.completedPercent;
						// this.resourceDetail.resource.duration = '00:00:00';
						this.resourceDetail.playlistReadData = response.playlist;
						this.CCVAdditionalData.read = this.resourceDetail.read;
						if ((this.resourceDetail.resourceFormat && ['document', 'page', 'link'].includes(this.resourceDetail.resourceFormat.key))
							|| (this.resourceDetail.resourceTypeID.key && ['answer'].includes(this.resourceDetail.resourceTypeID.key))) {
							if (this.resourceDetail.resource && this.resourceDetail.resource.duration) {
								this.CCVAdditionalData.readTime = (!['00:00', '00:00:00'].includes(this.resourceDetail.resource.duration)) ? this.gfService.getTimeDuration(this.resourceDetail.resource.duration, 'minutes') : '';
							}
						}
						if (this.resourceDetail.resourceAction && this.resourceDetail.resourceAction.readLog) {
							if (this.resourceDetail.resourceTypeID && !['knowledgecard', 'playlist', 'course'].includes(this.resourceDetail.resourceTypeID.key)) {
								if (['answer'].includes(this.resourceDetail.resourceTypeID.key)) {
									if (!this.resourceDetail.read) {
										if (this.resourceDetail.resource.duration) {
											this.processTimeLog();
										} else {
											this.addReadLog('time', 'general');
										}
									}
								}
								if (this.resourceDetail.resourceFormat) {
									if (['audio', 'video', 'page', 'document'].includes(this.resourceDetail.resourceFormat.key) && this.resourceDetail.resource) {
										if (['audio', 'video'].includes(this.resourceDetail.resourceFormat.key) && this.resourceDetail.resource.file) {
											if (!this.resourceDetail.read) {
												this.canStartPlay = true;
												// this.getReadSegmentLog();
											} else {
												this.canStartPlay = true;
											}
										} else if (['document'].includes(this.resourceDetail.resourceFormat.key) && !this.resourceDetail.read) {
											if (this.resourceDetail.resource.duration) {
												this.processTimeLog();
											}
											// this.getReadTimeLog();
										}
									} else if (this.resourceDetail.resourceFormat.key === 'link') {
										if (!this.resourceDetail.read && this.resourceDetail.resource && (!this.resourceDetail.resource.urlData || (this.resourceDetail.resource.urlData && this.resourceDetail.resource.urlData.type === 'youtube'))) {
											this.readExternalLinkLog();
										}
									}
								}
							}
							if (!this.resourceDetail.read && this.resourceDetail.resource && this.resourceDetail.resource.image && this.resourceDetail.resource.image.length) {
								if ((this.detectDevice.resolutionState$.value.xl && this.resourceDetail.resource.image.length <= 8) || (this.detectDevice.resolutionState$.value.lg && this.resourceDetail.resource.image.length <= 6) || ((this.detectDevice.resolutionState$.value.md || this.detectDevice.resolutionState$.value.sm) &&
									this.resourceDetail.resource.image.length <= 4) || (this.detectDevice.resolutionState$.value.xs && this.resourceDetail.resource.image.length <= 2)) {
									this.readMoreForImage({});
								}
							}
						} else {
							this.canStartPlay = true;
						}
					}
				}
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		)
			.add(() => {
				this.processed = true;
				this.resourceLoader = false;
				this.playlistLoader = false;
				if (this.popupRef && this.popupRef.componentInstance) {
					this.popupRef.componentInstance.popupLoader = false;
				}
				this.cdref.detectChanges();
				this.loadYouTube();
			});
	}

	processReadForImage() {
		if (navigator.onLine) {
			if (this.resourceDetail && !this.resourceDetail.read && this.resourceDetail.resourceAction && this.resourceDetail.resourceAction.readLog && this.resourceDetail.resourceFormat && this.resourceDetail.resourceFormat.key && this.resourceDetail.resourceFormat.key === 'image') {
				// this.gfService.blockHttpCall = false;
				this.addReadLog('time', 'general', { cancelable: 'N' });
			}
		}
	}

	processReadForEvents() {
		if (navigator.onLine) {
			if (this.resourceDetail && !this.resourceDetail.read && this.resourceDetail.resourceAction && this.resourceDetail.resourceAction.readLog && this.resourceDetail.resourceTypeID && this.resourceDetail.resourceTypeID.key && ['internalEvent', 'externalEvent'].includes(this.resourceDetail.resourceTypeID.key)) {
				// this.gfService.blockHttpCall = false;
				this.addReadLog('time', 'general', { cancelable: 'N' });
			}
		}
	}
	processReadForMOOC() {
		if (navigator.onLine) {
			if (this.resourceDetail && !this.resourceDetail.read && this.resourceDetail.resourceAction && this.resourceDetail.resourceAction.readLog && this.resourceDetail.resourceTypeID && this.resourceDetail.resourceTypeID.key && ['mooc'].includes(this.resourceDetail.resourceTypeID.key)) {
				// this.gfService.blockHttpCall = false;
				this.addReadLog('time', 'general', { cancelable: 'N' });
			}
		}
	}

	readMoreForImage(event) {
		if (!this.timeProcessed) {
			if (event.enabled) {
				if (event.read) {
					this.processReadForImage();
					this.timeProcessed = true;
				}
			} else {
				this.processReadForImage();
				this.timeProcessed = true;
			}
		}
	}

	viewImage(imageIndex, image) {
		if (!image.error) {
			const dialogRef = this.popup.open(PopupComponent, {
				panelClass: ['custom-panel'],
				data: {
					action: 'dynamic',
					popup: true,
					component: ResourceFormsComponent,
					componentData: [
						{
							variableName: 'action',
							value: 'viewImage'
						},
						{
							variableName: 'imageIndex',
							value: imageIndex
						},
						{
							variableName: 'resourceDetail',
							value: this.resourceDetail
						}
					]
				},
				disableClose: true,
				maxHeight: '100%',
				maxWidth: '950px',
				height: '100%',
				autoFocus: false
			});
			dialogRef.afterClosed().subscribe(async (result) => {
				if (result && typeof result === 'object') {
				}
			});
		}
	}

	getUsersProfile() {
		if (this.resourceDetail && Array.isArray(this.resourceDetail.authors)) {
			const dialogRef = this.popup.open(PopupComponent, {
				panelClass: ['custom-panel'],
				autoFocus: false,
				data: {
					action: 'users',
					popup: true,
					usersList: this.resourceDetail.authors
				},
				disableClose: true,
				maxWidth: '800px'
			});
			dialogRef.afterClosed().subscribe(async (result) => {
				if (result) {
				}
			});
		}
	}

	dataBuild(data) {
		this.optionMenu = [];
		// data.status = 3;
		// data.currentTime = '00:00:11';
		// data.read = 1;
		// data.resource.file = 'https://file-examples-com.github.io/uploads/2017/08/file_example_PPT_250kB.ppt';
		if (data.createdUser) {
			data.createdUser.name = `${data.createdUser.firstName}${data.createdUser.lastName
				? ' ' + data.createdUser.lastName
				: ''}`;
		}
		data.actionFrom = this.actionFrom;
		data.status = this.baseService.referenceType('resourceStatus', data.status);
		if (data.registrationStatus) {
			data.registrationStatus = this.baseService.referenceType('registrationStatus', data.registrationStatus);
		}
		if (![null, undefined].includes(data.registrationRequestStatus)) {
			data.registrationRequestStatus = this.baseService.referenceType('registrationRequestStatus', data.registrationRequestStatus);
		}
		if (this.popupRef && this.popupRef.componentInstance && this.popupRef.componentInstance.dialogCloseData) {
			this.popupRef.componentInstance.dialogCloseData.resourceStatus = data.status;
		}
		data.resourceTypeID = this.baseService.referenceType(
			'resourceType',
			data.resourceTypeID
		);
		if (data.resourceFormat && data.resourceTypeID) {
			data.resourceFormat = this.baseService.referenceType('resourceFormat', data.resourceFormat);
			if (data.resourceFormat.key === 'document') {
				if (data.resource && data.resource.file) {
					const fileExt = data.resource.file.split('.').pop().toLowerCase();
					if (fileExt === 'pdf') {
						data.resource.file = data.resource.file + '#toolbar=0';
					} else {
						data.resource.file = `https://view.officeapps.live.com/op/embed.aspx?src=${data.resource.file}`;
					}
				}
			} else if (data.resourceFormat.key === 'link' && !['knowledgecard', 'playlist'].includes(data.resourceTypeID.key)) {
				if (data.resource && data.resource.link) {
					data.resource.urlData = this.gfService.embed(data.resource.link);
				}
				if (data.resource.thumbnail === '') {
					data.resource.thumbnail = data.resourceFormat.image;
				}
			}
		}
		// if (data.skills && data.skills.length) {
		// 	for (const skill of data.skills) {
		// 		const sliderValue = this.currentUser.weightageData.find(items => items.termID === skill.skilllevels.key);
		// 		if (sliderValue) {
		// 			skill.progress = ((sliderValue.index / this.currentUser.weightageData.length) * 100).toFixed(2);
		// 		} else {
		// 			skill.progress = 0;
		// 		}
		// 	}
		// }
		if (data.infoFields && data.infoFields.experts && data.infoFields.experts.length) {
			for (const expert of data.infoFields.experts) {
				expert.name = `${expert.firstName}${expert.lastName
					? ' ' + expert.lastName
					: ''}`;
			}
		}
		if ([null, undefined, ''].includes(this.type)) {
			let type = 'assign_to_me';
			if (data.resourceTypeID.key === 'knowledgecard') {
				if (data.authors && data.authors.length) {
					if (data.authors.find(items => items.userID === this.currentUser.userID)) {
						type = 'assign_by_me';
					}
				}
			}
			this.type = type;
			this.cdref.detectChanges();
		}
		const actions = this.baseService.getResourceAction(data, this.actionFrom);
		
		data.resourceAction = actions;
		// if (data.status && data.status.key === 'moderation' && data.resourceAction && data.resourceAction.publishUnPublish) {
		// 	this.gfService.resourceDetailScroll = false;
		// }
		console.log(actions);
		// let isAuthor = false;
		// let isAdmin = this.baseService.checkAccessControl('P07');
		if (actions.publishUnPublish) {
			this.optionMenu.push(
				{
					key: (data.status.key === 'published') ? 'unPublish' : 'publish',
					caption: this.locale.translate((data.status.key === 'published') ? 'un_publish' : 'publish'),
					classes: [],
					disabled: false
				}
			);
		}
		if (actions.edit) {
			this.optionMenu.push(
				{
					key: 'resourceEdit',
					caption: this.locale.translate('edit'),
					classes: [],
					disabled: false
				}
			);
		}
		if (actions.settings) {
			this.optionMenu.push(
				{
					key: 'settings',
					caption: this.locale.translate('settings'),
					classes: [],
					disabled: false
				}
			);
		}
		if (actions.delete) {
			this.optionMenu.push(
				{
					key: 'delete',
					caption: this.locale.translate('delete'),
					classes: [],
					disabled: false
				}
			);
		}
		if (actions.closeQuestion && !actions.joinInAsking) {
			this.optionMenu.push(
				{
					key: 'closeQuestion',
					caption: this.locale.translate('close_question'),
					classes: [],
					disabled: false
				}
			);
		}
		if (actions.makePublic) {
			this.optionMenu.push(
				{
					key: 'makePublic',
					caption: this.locale.translate('make_public'),
					classes: [],
					disabled: false
				}
			);
		}
		let features: Features = {};
		if (data.resourceTypeID && !['knowledgecard'].includes(data.resourceTypeID.key)) {
			features.title = data.resourceTypeID.caption;
			features.manage = {
				order: 6,
				data: []
			};
			features.feature = {
				order: 3,
				data: []
			};
			features.assignment = {
				order: 4,
				data: []
			}
			// if (data.createdBy === this.currentUser.userID && !['published', 'moderation'].includes(data.status.key)) {
			// 	features.manage.data.push({
			// 		icon: 'edit',
			// 		emit: true,
			// 		toolTip: this.locale.translate('edit_resource'),
			// 		key: 'resourceEdit'
			// 	});
			// }
			features.rating = {
				value: 0,
				order: 2,
				disabled: !actions.rating,
				count: 0
			};
			if (data.stats && Object.keys(data.stats).length > 0) {
				features.rating.value = data.stats.avgRating || 0;
				features.rating.count = data.stats.ratingCount || 0;
			}
			// if (data.createdBy === this.currentUser.userID) {
			if (actions.assign) {
				features.assignment.data.push(
					{
						type: 'sub-action-button',
						caption: this.locale.translate('assign'),
						emit: true,
						key: 'assign'
					}
				);
			}
			if (actions.manage) {
				features.assignment.data.push(
					{
						type: 'sub-cancel-button',
						caption: this.locale.translate('manage'),
						emit: true,
						key: 'manage'
					}
				);
			}
			if (actions.forward) {
				features.feature.data.push(
					{
						svgIcon: 'forward_outline',
						emit: true,
						toolTip: this.locale.translate('forward'),
						key: 'forward'
					}
				);
			}
			if (actions.addToPlaylist) {
				features.feature.data.push(
					{
						svgIcon: 'playlist_plus',
						emit: true,
						toolTip: this.locale.translate('add_to_playlist'),
						key: 'addToPlaylist'
					}
				);
			}
			if (actions.bookmark) {
				features.feature.data.push(
					{
						svgIcon: 'bookmark_outline',
						emit: true,
						toolTip: this.locale.translate('bookmark'),
						key: 'bookmark',
						disabled: false
					}
				);
			}
			if (actions.clipboard) {
				features.feature.data.push(
					{
						svgIcon: 'copy_url',
						emit: true,
						toolTip: this.locale.translate('copy_resource_url_to_clipboard'),
						key: 'clipboard',
						disabled: false
					}
				);
			}
			if (data.settings && Object.keys(data.settings).length && data.status.key === 'published') {
				if (data.settings.collaborators) {
					features.manage.data.push(
						{
							icon: 'supervisor_account',
							emit: false,
							toolTip: '',
							key: 'collaboration'
						}
					);
				}
				if (data.settings.setVisibility) {
					features.manage.data.push(
						{
							icon: 'report',
							emit: false,
							toolTip: '',
							key: 'visibility'
						}
					);
				}
			}
			if (!([null, undefined, false].includes(data.stats)) && actions.stats) {

				if (data.readGraph && data.readGraph.data && data.readGraph.data.length) {
					const labels = [];
					for (const line of data.readGraph.data) {
						labels.push('');
					}
					let learningChart: LineChartModel = {
						datasets: [
							{
								data: data.readGraph.data,
								label: ['test'],
								borderColor: '#5377d9',
								backgroundColor: "#a5c2f4",
								fill: true,
								borderWidth: 1
							}
						],
						labels
					};
					let learningOptions: LineOptionsModel = {
						legend: {
							display: false
						},
						tooltips: {
							enabled: false
						},
						scales: {
							yAxes: [
								{
									ticks: {
										display: false,
										beginAtZero: true
									},
									gridLines: {
										display: false,
										tickMarkLength: false
									}
								}
							],
							xAxes: [
								{
									ticks: {
										display: false,
										beginAtZero: true
									},
									gridLines: {
										display: false,
										tickMarkLength: false
									}
								}
							]
						},
						maintainAspectRatio: false,
						disablePointerEvents: true,
						bezierCurve: false,
						animation: {
							duration: 0 // general animation time
						},
						hover: {
							animationDuration: 0 // duration of animations when hovering an item
						},
						responsiveAnimationDuration: 0, // animation duration after a resize
						showTooltips: false,
						elements: {
							line: {
								tension: 0
							},
							point: {
								radius: 0
							}
						}
					};
					const chartData = {
						chartData: learningChart,
						chartOption: learningOptions
					};

					features.stats = {
						type: 'lineChart',
						data: chartData,
						// assignedCount: 0,
						// messageCount: data.stats.conversationCount,
						// sharedCount: data.stats.forwardingCount,
						imageSrc: null,
						order: 5,
						caption: new HandleBarPipe().transform(this.locale.translate('read_graph_text'), { count: data.readGraph.totalReads, days: 15 })
					};
				}
				if (data.settings) {
					if (data.settings.forwarding) {
						features.stats.sharedCount = data.stats.forwardingCount || 0;
					}
					if (data.settings.assign) {
						features.stats.assignedCount = data.stats.assignmentCount || 0;
					}
					if (data.settings.commenting !== 'hide') {
						features.stats.messageCount = data.stats.conversationCount || 0;
					}
				}
			}
		}
		if (data.authors && data.authors.length) {
			// if (data.authors.find(items => items.userID === this.currentUser.userID)) {
			// 	isAuthor = true;
			// }
			if (data.authors[0].userID) {
				if (features && features.title) {
					features.author = {
						imageSrc: data.authors[0].profilePicURL,
						name: `${data.authors[0].firstName}${data.authors[0].lastName
							? ' ' + data.authors[0].lastName
							: ''}`,
						count: 0,
						createdAt: this.gfService.dateFormat(data.createdAt, 'dd MMM yyyy'),
						order: 1
					};
				}

				this.authorData = {
					userID: data.authors[0].userID
				};
			} else if (data.authors[0].Name && features && features.title) {
				features.author = {
					imageSrc: null,
					name: data.authors[0].Name,
					count: 0,
					createdAt: this.gfService.dateFormat(data.createdAt, 'dd MMM yyyy'),
					order: 1
				};
			}
			if (data.authors.length > 1) {
				features.author.count = data.authors.length - 1;
			}
		} else {
			features.author = {
				imageSrc: null,
				name: null,
				count: 0,
				createdAt: this.gfService.dateFormat(data.createdAt, 'dd MMM yyyy'),
				order: 1
			};
		}
		if (data.settings && Object.keys(data.settings).length) {
			data.settings.commenting = actions.conversation;
		} else {
			data.settings = {
				commenting: actions.conversation
			};
		}
		const linkedResource = [];
		if (data.linkedResource && data.linkedResource.length) {
			for (const resource of data.linkedResource) {

				let finalData: any = {};
				if (resource.resourceTypeID) {
					resource.resourceTypeID = this.baseService.referenceType('resourceType', resource.resourceTypeID);
					if (resource.resourceTypeID.key === 'answer') {
						const cardData: QuestionCard = {
							title: resource.title,
							// date: this.gfService.dateFormat(data.createdAt, 'd MMM'),
							thumbnail: '',
							// removable: true
						};
						// if (data.authors && data.authors.length) {
						// 	cardData.thumbnail = data.authors[0].profilePicURL;
						// 	cardData.creator = `${data.authors[0].firstName}${data.authors[0].lastName
						// 		? ' ' + data.authors[0].lastName
						// 		: ''}`;
						// 	if (data.authors.length > 1) {
						// 		cardData.usersCount = (data.authors.length - 1);
						// 	}
						// }

						finalData = cardData;
					} else if (resource.resourceTypeID.key === 'playlist') {
						const cardData: PlaylistCard = {
							title: resource.title,
							// date: this.gfService.dateFormat(data.createdAt, 'd MMM'),
							// type: resource.resourceType.caption,
							thumbnail: '',
							// removable: true
							// playlistItemCount: data.count
						};

						finalData = cardData;
					} else if (['internalEvent', 'externalEvent'].includes(resource.resourceTypeID.key)) {
						const cardData: EventCard = {
							thumbnail: '',
							title: resource.title,
							eventType: (resource.resourceTypeID && resource.resourceTypeID.key) ? resource.resourceTypeID.key : null,
							// removable: true
						};
						if (resource.resourceTypeID) {
							// if (data.infoFields) {
							// 	if (data.resourceType.key === 'internalEvent') {
							// 		if (data.infoFields.time) {
							// 			cardData.time = this.gfService.dateFormat(data.infoFields.time, 'shortTime');
							// 		}
							// 		if (data.infoFields.date.length) {
							// 			cardData.date = `${this.gfService.dateFormat(data.infoFields.date[0], 'd')} ${this.gfService.dateFormat(data.infoFields.date[0], 'MMM')} - ${this.gfService.dateFormat(data.infoFields.date[1], 'd')} ${this.gfService.dateFormat(data.infoFields.date[1], 'MMM')}`;
							// 		}
							// 	} else {
							// 		if (data.infoFields.date) {
							// 			cardData.date = this.gfService.dateFormat(data.infoFields.date, 'd MMM');
							// 		}
							// 	}
							// }
						}

						finalData = cardData;
					} else {
						const cardData: ContentImageCard = {
							title: resource.title,
							// date: this.gfService.dateFormat(resource.createdAt, 'MMM d, y'),
							thumbnail: '',
							// removable: true
						};
						finalData = cardData;

					}

					finalData.type = resource.resourceTypeID.caption;
				}

				if (resource.resource.hasOwnProperty('duration')) {
					finalData.duration = resource.resource.duration;
				}

				if (resource.resource && resource.resource.thumbnail && resource.resourceTypeID && resource.resourceTypeID.key !== 'answer') {
					finalData.thumbnail = resource.resource.thumbnail;
				}
				if (resource.resourceFormat) {
					resource.resourceFormat = this.baseService.referenceType('resourceFormat', resource.resourceFormat);
					finalData.format = resource.resourceFormat.key;
					if (finalData.thumbnail === '') {
						finalData.thumbnail = resource.resourceFormat.image;
					}
				}

				const extraData = {
					resourceID: resource.resourceID,
					createdBy: resource.createdBy
				};
				linkedResource.push(this.gfService.JSONMerge(finalData, extraData));
			}
			data.linkedResource = linkedResource;
		}
		this.features = features;
		// setTimeout(() => {
		// 	this.test();
		// }, 5000);
	}

	loadYouTube() {
		if (navigator.onLine) {
			if (this.resourceDetail && this.resourceDetail.resource && this.resourceDetail.resource.urlData && this.resourceDetail.resource.urlData.isFormatted && this.resourceDetail.resource.urlData.type === 'youtube') {
				this.youtubeLoader = true;
				let videoId = this.resourceDetail.resource.link.split('v=')[1];
				const ampersandPosition = videoId.indexOf('&');
				if (ampersandPosition != -1) {
					videoId = videoId.substring(0, ampersandPosition);
				}
				this.YTPlayer = new (<any>window).YT.Player('YTPlayer', {
					height: '100%',
					width: '100%',
					videoId,
					playerVars: { 'autoplay': 0, 'rel': 0, 'controls': 2 },
					events: {
						'onReady': () => {
							this.youtubeLoader = false;
							this.setYouTubeSegmentData();
							if (navigator.onLine && this.resourceDetail.lastTimeline) {
								const duration = this.gfService.getTimeToSeconds(this.resourceDetail.lastTimeline, { timeFormat: 'hh:mm:ss', duration: 'seconds' });
								this.YTPlayer.seekTo(duration, true);
								this.YTPlayer.playVideo();
							}
						},
						'onStateChange': (event) => {
							this.processYouTube(event);
						}
					}
				});
			}
		}
	}

	setYouTubeSegmentData() {
		if (!this.resourceDetail.read && navigator.onLine && this.resourceDetail.resourceAction && this.resourceDetail.resourceAction.readLog) {
			this.totalYoutubeSegments = Math.round(this.YTPlayer.getDuration() / this.appInit.configuration.videoReadSeconds);
			if (this.totalYoutubeSegments) {
				for (let i = 1; i <= this.totalYoutubeSegments; i++) {
					let start = (i - 1) * this.appInit.configuration.videoReadSeconds;
					let end = i * this.appInit.configuration.videoReadSeconds;
					if (i === this.totalYoutubeSegments) {
						end = this.YTPlayer.getDuration();
					}
					this.youtTubeSegmentData.push(
						{
							start,
							end
						}
					);
				}
			}
		}
	}

	resetYouTubeProcess() {
		if (this.youTubeTimeInterval) {
			clearInterval(this.youTubeTimeInterval);
		}
		localStorage.removeItem('segmentData');
		this.youtTubeSegmentedData = [];
		this.youtTubeSegmentData = [];
		this.totalYoutubeSegments = 0;
		this.oldYouTubeSegmentIndex = null;
		this.YTStatus = false;
		this.YTIntervalCleared = false;
		this.YTPlayerReached = false;
	}

	processYouTube(event) {
		if (!this.YTPlayerReached && navigator.onLine && this.resourceDetail.resourceAction && this.resourceDetail.resourceAction.readLog) {
			if (!this.YTStatus) {
				this.YTStatus = true;
				this.youTubeTimeInterval = setInterval(() => {

					if (this.youTubeTimeInterval && this.resourceDetail.status && this.resourceDetail.status.key !== 'published') {
						this.resetYouTubeProcess();
					} else {
						if (this.resourceDetail.read) {
							this.updatedTime(this.YTPlayer.getCurrentTime());
						} else {
							const index = this.youtTubeSegmentData.findIndex(items => items.start <= this.YTPlayer.getCurrentTime() && items.end >= this.YTPlayer.getCurrentTime());
							if (((this.YTPlayer.getCurrentTime() >= this.appInit.configuration.videoReadSeconds || index === 0) &&
								index !== -1 && ([null, undefined].includes(this.oldYouTubeSegmentIndex) || this.oldYouTubeSegmentIndex !== index))
								|| this.YTPlayer.getDuration() <= this.appInit.configuration.videoReadSeconds) {
								this.youtTubeSegmentedData.push(index + 1);
								this.youtTubeSegmentedData.sort();
								this.YTStatus = false;
								this.YTIntervalCleared = false;
								this.YTPlayerReached = true;

								if ((index + 1) === this.totalYoutubeSegments) {
									// To add read log if 80% of video segment is passed
									this.addReadLog('segment', 'general', { cancelable: 'N' });
									this.YTIntervalCleared = true;
									clearInterval(this.youTubeTimeInterval);
									localStorage.removeItem('segmentData');
								} else {
									const segmentData = {
										totalSegment: this.totalYoutubeSegments,
										segments: this.youtTubeSegmentedData,
										currentSegment: index + 1,
										currentTime: this.gfService.formatTime(Math.round(this.YTPlayer.getCurrentTime()), 'hh:mm:ss')
									};
									this.segments(segmentData);
								}
								// } else
								if (event.data === 2) {
									// To clear Internal at end of the video
									this.YTIntervalCleared = true;
									clearInterval(this.youTubeTimeInterval);
								}

								this.oldYouTubeSegmentIndex = index;
							}
						}
					}
				}, 1000);
			}
			if (event.data === 2) {
				this.YTIntervalCleared = true;
				clearInterval(this.youTubeTimeInterval);
			} else if (event.data === 1 && this.YTStatus && this.YTIntervalCleared) {
				this.YTStatus = false;
				this.YTIntervalCleared = false;
				this.processYouTube(event);
			}
		}
	}

	getReadSegmentLog() {
		const apiData = {};
		const headers: any = {};
		this.apiService.getReadSegmentLog(apiData, this.resourceID, headers).subscribe(
			(response) => {
				if (response) {
					response = response.map(data => { return data.toString() });
					let storageData = [];
					if (localStorage.getItem('segmentData')) {
						storageData = JSON.parse(localStorage.getItem('segmentData'));
					}
					const currentSegmentData = storageData.find(items => items.resourceID === this.resourceID);
					if (currentSegmentData) {
						currentSegmentData.segments = response;
						currentSegmentData.currentSegment = response.currentSegment;
					} else {
						const pushJson: any = {
							resourceID: this.resourceID,
							segments: response,
							currentSegment: response.currentSegment
						};
						storageData.push(pushJson);
					}
					localStorage.setItem('segmentData', JSON.stringify(storageData));
				}
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		)
			.add(() => {
				this.canStartPlay = true;
			});
	}

	getReadTimeLog() {
		const apiData = {};
		const headers: any = {};
		this.apiService.getReadTimeLog(apiData, this.resourceID, headers).subscribe(
			(response) => {
				if (response && response.totalTimeSpent) {
					let storageData = [];
					if (localStorage.getItem('timeLogData')) {
						storageData = JSON.parse(localStorage.getItem('timeLogData'));
					}
					const currentSegmentData = storageData.find(items => items.resourceID === this.resourceID);
					if (currentSegmentData) {
						currentSegmentData.currentTime = response.totalTimeSpent;
					} else {
						storageData.push(
							{
								resourceID: this.resourceID,
								totalDurationInSeconds: this.hmsToSecondsOnly(this.resourceDetail.resource.duration),
								totalDuration: this.resourceDetail.resource.duration,
								currentTime: response.totalTimeSpent
							}
						);
					}
					localStorage.setItem('timeLogData', JSON.stringify(storageData));
				}
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		)
			.add(() => {
				if (this.resourceDetail.resource && this.resourceDetail.resource.duration) {
					this.processTimeLog();
				}
			});
	}

	readExternalLinkLog() {
		setTimeout(() => {
			if (this.resourceDetail.resource.urlData.type !== 'youtube') {
				this.addReadLog('time', 'general', { cancelable: 'N' });
			}
		}, this.appInit.configuration.externalLinkLogTime);
	}

	readMore(event) {
		if (!this.timeProcessed) {
			if (event.enabled) {
				if (event.read) {
					this.processTimeLog();
					this.timeProcessed = true;
				}
			} else {
				this.processTimeLog();
				this.timeProcessed = true;
			}
		}
	}

	resetTimeLog() {
		if (this.timeLogInterval) {
			this.timeLogInterval.clearInterval();
		}
		this.intervalCleared = true;
		localStorage.removeItem('timeLogData');
	}

	processTimeLog() {
		if (this.resourceDetail.resourceAction && this.resourceDetail.resourceAction.readLog && !this.resourceDetail.read) {
			this.intervalCleared = false;
			this.timeLogInterval = this.gfService.intervalTimer(() => {
				if (this.timeLogInterval && this.resourceDetail.status && this.resourceDetail.status.key !== 'published') {
					this.resetTimeLog();
				} else {
					let storageData: any = [];
					if (localStorage.getItem('timeLogData')) {
						storageData = JSON.parse(localStorage.getItem('timeLogData'));
					}
					const findData = storageData.find(items => items.resourceID === this.resourceID);
					if (findData) {
						if (findData.totalDurationInSeconds <= findData.newTime) {
							if (this.timeLogInterval) {
								this.addReadLog('time', 'general');
								this.timeLogInterval.clearInterval();
								this.intervalCleared = true;
							}
						} else {
							findData.currentTime = Number(findData.currentTime);
							findData.currentTime += (this.appInit.configuration.pageReadLogTime / 1000);
							findData.newTime = findData.currentTime;
						}
					} else {
						const pushJson: any = {
							resourceID: this.resourceID,
							totalDurationInSeconds: this.hmsToSecondsOnly(this.resourceDetail.resource.duration),
							totalDuration: this.resourceDetail.resource.duration,
							currentTime: (this.appInit.configuration.pageReadLogTime / 1000),
							newTime: (this.appInit.configuration.pageReadLogTime / 1000)
						};
						if (pushJson.totalDurationInSeconds <= pushJson.newTime) {
							this.addReadLog('time', 'general');
							this.resetTimeLog();
						} else {
							storageData.push(pushJson);
						}
					}
					// const currentTimeData = storageData.find(items => items.resourceID === this.resourceID);
					// if (currentTimeData) {
					// 	const percentage = (currentTimeData.currentTime / currentTimeData.totalDurationInSeconds) * 100;
					// 	if (percentage >= this.appInit.configuration.pageReadPercentage) {
					// 		if (this.timeLogInterval) {
					// 			clearInterval(this.timeLogInterval);
					// 		}
					// 		this.readTimeLog = false;
					// 		this.addReadLog('time');
					// 	} else {
					// 		this.readTimeLog = true;
					// 	}
					// }

					const currentTimeData = storageData.find(items => items.resourceID === this.resourceID);
					if (currentTimeData) {
						if (this.playlistParentData && !this.playlistParentData.read && this.playlistData && this.playlistData.length) {
							let count = 0;
							for (const data of this.playlistData) {
								if (data.watched) {
									count += 1;
								}
							}
							const percentage = (count / this.playlistData.length) * 100;
							if (percentage) {
								currentTimeData.playlistParentPercentage = percentage;
								currentTimeData.playlistParentID = this.playlistParentData.resourceID;
							}
						}
					}
					if (!this.intervalCleared && this.timeLogInterval && storageData.length) {
						localStorage.setItem('timeLogData', JSON.stringify(storageData));
						console.log(storageData);
					}

					// if (this.resourceDetail.resourceFormat && this.resourceDetail.resourceFormat.key) {
					// 	if (['video', 'audio'].includes(this.resourceDetail.resourceFormat.key) && storageData.length) {
					// 		const findData = storageData.find(items => items.resourceID === this.resourceID);
					// 		if (findData.currentSegment === findData.totalSegment) {
					// 			this.addReadLog('segment', 'general', { cancelable: 'N' });
					// 			localStorage.removeItem('segmentData');
					// 		}
					// 	}
					// }


				}
			}, this.appInit.configuration.pageReadLogTime);
			document.addEventListener('visibilitychange', (e) => {
				if (!this.intervalCleared) {
					if (document.hidden) {
						this.timeLogInterval.pause();
					} else {
						this.timeLogInterval.resume();
					}
				}
			});
		}
	}

	hmsToSecondsOnly(str) {
		var p = str.split(':'),
			s = 0, m = 60;

		while (p.length > 0) {
			s += m * parseInt(p.pop(), 10);
			m *= 60;
		}

		return s;
	}

	// trackBy(index, items) {
	// 	console.log(items, this['key']);
	// }

	pageActions(actions) {
		if (navigator.onLine) {
			this.updateRead(actions, 'playlistNavigation');
		}
	}

	playlistNavigation(actions) {
		this.actionBtns = actions.actionBtns;
		this.selectedPlaylistQueueIndex = actions.selectedIndex;
		this.resourceLoader = true;
		this.assignmentLoader = true;
		this.featureLoader = true;
		this.assignmentID = null;
		this.type = actions.data.creatorType;
		this.resourceDetail.resourceID = null;
		delete this.resourceDetail.resourceTypeID;
		this.assignmentDetail = {
			status: { key: '' }
		};
		this.resourceID = actions.data.resourceID;
		this.actionFrom = 'playlist_item';
		if (this.resourceID) {
			this.getDetail();
		}
	}

	playActions(action) {
		if (navigator.onLine) {
			const data = { type: action };
			this.actionType = { ...data };
		}
	}

	manageAssignment(record) {
		if (navigator.onLine) {
			if (record.data.key === 'manage') {
				this.popup.closeAll();
				this.gfService.routeNavigation('assignment', {
					tab: 'assign_by_me'
				});
				// const dialogRef = this.popup.open(PopupComponent, {
				// 	panelClass: ['custom-panel'],
				// 	data: {
				// 		action: 'dynamic',
				// 		popup: true,
				// 		component: AssigneesComponent,
				// 		componentData: [
				// 			{
				// 				variableName: 'resourceDetail',
				// 				value: this.resourceDetail
				// 			}
				// 		],
				// 		triggerEl: record.actionElement
				// 	},
				// 	disableClose: true,
				// 	maxWidth: '860px',
				// 	autoFocus: false
				// });
				// dialogRef.afterClosed().subscribe(async (result) => {
				// 	if (result && typeof result === 'object' && result.assign) {
				// 		this.assign(record);
				// 	}
				// });
			} else if (record.data.key === 'assign') {
				this.assign(record);
			}
		}
	}

	forwardResource(data) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: ResourceFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'forwardResource'
					},
					{
						variableName: 'resourceDetail',
						value: this.resourceDetail
					}
				],
				triggerEl: data.actionElement
			},
			disableClose: true,
			maxWidth: '600px'
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result && typeof result === 'object') {
				if (result.toUserID && Array.isArray(result.toUserID) && this.features && this.features.stats && this.features.stats.hasOwnProperty('sharedCount')) {
					this.features.stats.sharedCount = this.features.stats.sharedCount + result.toUserID.length;
				}
			}
		});

	}

	assign(record) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: AssignmentUpdateComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'assign'
					},
					{
						variableName: 'resourceDetail',
						value: this.resourceDetail
					}
				],
				triggerEl: record.actionElement
			},
			disableClose: true,
			maxWidth: '860px',
			autoFocus: true
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result && typeof result === 'object') {
				if (!this.assignmentDetail) {
					this.reloadAssignment = true;
				}
				if (result.assignee && Array.isArray(result.assignee) && this.features && this.features.stats && this.features.stats.hasOwnProperty('assignedCount')) {
					this.features.stats.assignedCount = this.features.stats.assignedCount + result.assignee.length;
				}
			}
		});
	}

	updateCommentCount(count) {
		this.features.stats.messageCount = count;
	}

	assignmentInfo(event) {
		this.assignmentDetail = event;
		if ([null, undefined].includes(this.assignmentDetail)) {
			this.reloadAssignment = false;
		}
		if (this.popupRef && this.assignmentDetail) {
			this.popupRef.componentInstance.dialogCloseData = this.assignmentDetail;
			if (this.resourceDetail) {
				if (this.assignmentDetail) {
					this.popupRef.componentInstance.dialogCloseData.resourceStatus = this.resourceDetail.status;

					this.resourceDetail.resourceAction.readLog = false;
					if (this.assignmentDetail.assignee) {
						if (this.assignmentDetail.assignee.userID === this.currentUser.userID) {
							this.resourceDetail.resourceAction.readLog = true;
							if (['internalEvent', 'externalEvent', 'mooc'].includes(this.resourceDetail.resourceTypeID.key)) {
								this.resourceDetail.resourceAction.registerLearning = true;

								if (this.resourceDetail.resourceTypeID.key === 'internalEvent') {
									this.resourceDetail.resourceAction.register = true;
									this.resourceDetail.resourceAction.requestForRegistration = true;
								} else if (['externalEvent', 'mooc'].includes(this.resourceDetail.resourceTypeID.key)) {
									this.resourceDetail.resourceAction.requestForApproval = true;
								}
							}
						}
					}

				} else {
					// this.popupRef.componentInstance.dialogCloseData = {
					// 	resourceStatus: this.resourceDetail.status,
					// };
				}
			}
		}
	}

	editImageResource() {
		const resourceFormat = this.resourceDetail.resourceFormat;
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: ResourceFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'editImageResource'
					},
					{
						variableName: 'resourceDetail',
						value: this.resourceDetail
					},
					{
						variableName: 'resourceFormatData',
						value: resourceFormat
					}
				]
			},
			disableClose: true,
			maxWidth: '860px',
			autoFocus: false
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result && result.imageData && Array.isArray(result.imageData)) {
				this.resourceDetail.resource.image = result.imageData;
				if (this.popupRef && this.popupRef.componentInstance.dialogCloseData) {
					this.popupRef.componentInstance.dialogCloseData.updated = true;
				}
			}
		});

	}

	optionInfo(action) {
		if (action.key === 'resourceEdit') {
			let editorialTypes = this.baseService.resourceType;
			let editorialKeys = [];
			editorialTypes.forEach((items) => {
				if (items.editorial) {
					editorialKeys.push(items.key);
				}
			});
			if (editorialKeys.includes(this.resourceDetail.resourceTypeID.key) || ['knowledgeBead', 'mooc', 'externalEvent','SCORM'].includes(this.resourceDetail.resourceTypeID.key)) {
				const resourceFormat = this.resourceDetail.resourceFormat;
				let action = '';
				let componentData = [
					{
						variableName: 'resourceDetail',
						value: this.resourceDetail
					},
					{
						variableName: 'resourceFormatData',
						value: resourceFormat
					}
				];
				let component: any = ResourceFormsComponent;
				if (this.resourceDetail.resourceTypeID.key === 'mooc') {
					action = 'editResource';
					componentData.push(
						{
							variableName: 'moocAdd',
							value: true
						}
					);
				} else if (this.resourceDetail.resourceTypeID.key === 'externalEvent') {
					action = 'editResource';
					componentData.push(
						{
							variableName: 'externalEventAdd',
							value: true
						}
					);
				} else if (this.resourceDetail.resourceTypeID.key === 'knowledgeBead') {
					action = 'editBeadResource';
				} else if (this.resourceDetail.resourceTypeID.key === 'SCORM'){
					action = 'editScorm'
				} else {
					action = 'editResource';
				}
				componentData.push(
					{
						variableName: 'action',
						value: action
					}
				);
				const dialogRef = this.popup.open(PopupComponent, {
					panelClass: ['custom-panel'],
					data: {
						action: 'dynamic',
						popup: true,
						component,
						componentData
					},
					disableClose: true,
					maxWidth: '860px',
					autoFocus: false
				});
				dialogRef.afterClosed().subscribe(async (result) => {
					if (result && typeof result === 'object') {
						this.resetYouTubeProcess();
						this.resetTimeLog();
						let resourceUpdated = false;
						if (this.popupRef && this.popupRef.componentInstance.dialogCloseData) {
							resourceUpdated = true;
						}
						// this.resourceLoader = true;
						if (this.popupRef) {
							this.popupRef.componentInstance.popupLoader = true;
						}
						this.resourceDetail.resourceID = null;
						delete this.resourceDetail.resourceTypeID;
						this.getDetail(resourceUpdated);
					}
				});
			} else if (this.resourceDetail.resourceTypeID.key === 'course') {
				this.updateCourse();
			} else if (this.resourceDetail.resourceTypeID.key === 'playlist') {
				this.updatePlaylist();
			} else if (this.resourceDetail.resourceTypeID.key === 'answer') {
				this.updateAnswer();
			} else if (this.resourceDetail.resourceTypeID.key === 'internalEvent') {
				this.updateInternalEvent();
			}
		} else if (action.key === 'delete') {
			this.alertPopup('deleteResource', null);
		} else if (action.key === 'publish' || action.key === 'unPublish') {
			this.alertPopup(action.key, null);
		} else if (action.key === 'settings') {
			this.settings();
		} else if (action.key === 'closeQuestion') {
			this.alertPopup(action.key, null);
			
		} else if (action.key === 'makePublic') {
			const headers: any = {};
			this.popupRef.componentInstance.popupLoader = true;
			this.workgroupApiService.getJoinedWGList(headers).subscribe(
				(response) => {
					this.popupRef.componentInstance.popupLoader = false;
					if (response && response.records && response.records.length) {
						this.alertPopup('makePublic', null);
					} else {
						this.makePublicPopup();
					}
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			).add(() => {
				this.popupRef.componentInstance.popupLoader = false;
			});
		}
	}

	makePublicPopup() {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: ResourceFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'makePublic'
					},
					{
						variableName: 'resourceDetail',
						value: this.resourceDetail
					}
				]
			},
			disableClose: true,
			maxWidth: '860px',
			autoFocus: false
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result && typeof result === 'object') {
				this.optionMenu = this.optionMenu.filter(items => items.key !== 'makePublic');
				if (this.popupRef) {
					if (this.popupRef.componentInstance.dialogCloseData) {
						this.popupRef.componentInstance.dialogCloseData.updated = true;
					}
				}
			}
		});
	}

	updateInternalEvent() {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: InternalEventFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'editEvent'
					},
					{
						variableName: 'record',
						value: this.resourceDetail
					}
				]
			},
			autoFocus: false,
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result && typeof result === 'object') {
				let resourceUpdated = false;
				if (this.popupRef && this.popupRef.componentInstance.dialogCloseData) {
					resourceUpdated = true;
				}
				// this.resourceLoader = true;
				if (this.popupRef) {
					this.popupRef.componentInstance.popupLoader = true;
				}
				this.resourceDetail.resourceID = null;
				delete this.resourceDetail.resourceTypeID;
				this.getDetail(resourceUpdated);
			}
		});
	}

	settings() {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: ResourceFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'settings'
					},
					{
						variableName: 'resourceDetail',
						value: this.resourceDetail
					}
				]
			},
			autoFocus: false,
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result && typeof result === 'object') {
				if (this.popupRef && this.popupRef.componentInstance.dialogCloseData) {
					this.popupRef.componentInstance.dialogCloseData.updated = true;
				}
				// this.resourceLoader = true;
				if (this.popupRef) {
					this.popupRef.componentInstance.popupLoader = true;
				}
				this.resourceDetail.resourceID = null;
				delete this.resourceDetail.resourceTypeID;
				this.getDetail();
			}
		});
	}

	manage(record) {
		if (record.data.key === 'addToPlaylist') {
			this.addToPlaylist(record, this.resourceDetail);
		} else if (record.data.key === 'forward') {
			this.forwardResource(record);
		} else if (record.data.key === 'bookmark') {
			this.setBookmark();
		} else if (record.data.key === 'clipboard') {
			this.copyToClipboard();
		}
	}

	copyToClipboard() {
		const url = `${window.location.protocol}//${window.location.hostname}${(window.location.port) ? `:${window.location.port}` : ''}/#/home?trigger=resource&resourceID=${this.resourceID}&popup=true&redirectTo=same`;
		this.gfService.copyToClipboard(url, this.locale.translate('resource_url_copied'));
	}

	updateCourse() {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: CourseFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'editCourse'
					},
					{
						variableName: 'record',
						value: this.resourceDetail
					}
				]
			},
			autoFocus: false,
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result && typeof result === 'object') {
				if (this.popupRef && this.popupRef.componentInstance.dialogCloseData) {
					this.popupRef.componentInstance.dialogCloseData.updated = true;
				}
				// this.resourceLoader = true;
				if (this.popupRef) {
					this.popupRef.componentInstance.popupLoader = true;
				}
				this.resourceDetail.resourceID = null;
				delete this.resourceDetail.resourceTypeID;
				this.getDetail();
			}
		});
	}

	updatePlaylist() {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: PlaylistFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'editPlaylist'
					},
					{
						variableName: 'record',
						value: this.resourceDetail
					}
				]
			},
			autoFocus: false,
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result && typeof result === 'object') {
				this.resourceDetail.title = result.title;
				this.resourceDetail.description = result.description;
				if (this.popupRef && this.popupRef.componentInstance.dialogCloseData) {
					this.popupRef.componentInstance.dialogCloseData.updated = true;
				}
			}
		});
	}

	updateAnswer() {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: QuestionsFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'editQuestion'
					},
					{
						variableName: 'resourceDetail',
						value: this.resourceDetail
					}
				]
			},
			disableClose: true,
			maxWidth: '860px',
			autoFocus: false
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result && typeof result === 'object') {
				this.resetTimeLog();
				let answerUpdated = false;
				if (this.popupRef && this.popupRef.componentInstance.dialogCloseData) {
					this.popupRef.componentInstance.dialogCloseData.updated = true;
					answerUpdated = true;
				}
				// this.resourceLoader = true;
				if (this.popupRef) {
					this.popupRef.componentInstance.popupLoader = true;
				}
				this.resourceDetail.resourceID = null;
				delete this.resourceDetail.resourceTypeID;
				this.getDetail(answerUpdated);
			}
		});
	}

	setBookmark() {
		if (navigator.onLine) {
			// this.featureLoader = true;
			const bookmark = this.features.feature.data.find(items => items.key === 'bookmark');
			if (bookmark) {
				bookmark.disabled = true;
				bookmark.classes = 'disabled';
			}
			const headers: any = {};
			this.apiService.addBookmark(this.resourceID, headers).subscribe(
				(response) => {
					this.baseService.logUserActivity('bookmark', 'engagement', [''], { resourceData: this.resourceDetail });
					this.gfService.openSnackBar('SUCCESS', {
						message: this.locale.translate('resource_bookmarked'),
						icon: 'check_circle_outline',
						position: 'before'
					});
				},
				(error) => {
					if (error.error.hasOwnProperty('errorCode') && error.error.errorCode === 'DUPLICATE') {
						error.error = this.locale.translate('the_resource_being_added_already_exists');
					}
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {
					if (bookmark) {
						bookmark.disabled = false;
						bookmark.classes = 'disabled';
					}
					// this.featureLoader = false;
				});
		}
	}

	alertPopup(action, data, additionalInfo: any = {}) {
		let content = '';
		let title = '';
		let buttons = [
			{
				type: 'main-action',
				caption: this.locale.translate('yes'),
				key: 'yes'
			},
			{
				type: 'main-action',
				caption: this.locale.translate('no'),
				key: 'no',
				autoFocus: true
			}
		];
		if (action === 'publish') {
			content = this.locale.translate('publish_resource_text');
			title = this.locale.translate('publish');
		} else if (action === 'unPublish') {
			content = this.locale.translate('un_publish_resource_text');
			title = this.locale.translate('un_publish');
		} else if (action === 'deleteResource') {
			content = this.locale.translate('Deleting_the_resource_will_break_references');
			title = this.locale.translate('delete');
		} else if (action === 'makePublic') {
			content = this.locale.translate('make_public_text');
			title = this.locale.translate('make_public');
		} else if (action === 'closeQuestion'){
			title = this.locale.translate('close_question');
			content =  this.locale.translate('close_question_resource_text');
		}
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			autoFocus: false,
			data: {
				action: 'alert',
				classes: 'warning',
				popup: true,
				icon: 'warning',
				title,
				content,
				buttons,
				triggerEl: additionalInfo.actionElement
			},
			disableClose: true,
			maxWidth: '560px'
		});
		dialogRef.afterClosed().subscribe((resp) => {
			if (resp) {
				if (resp.key === 'yes') {
					let playlistResourceStatus;
					if (action === 'publish' || action === 'unPublish') {
						const resourceStatus = this.baseService.resourceStatus;
						for (const status of resourceStatus) {
							if (status.key === 'published' && action === 'publish') {
								playlistResourceStatus = status.value;
							} else if (status.key === 'moderation' && action === 'unPublish') {
								playlistResourceStatus = status.value;
							}
						}
					}
					if (action === 'publish') {
						this.updateResourceStatus(playlistResourceStatus);
					} else if (action === 'unPublish') {
						this.updateResourceStatus(playlistResourceStatus);
					} else if (action === 'deleteResource') {
						this.deleteResource();
					} else if (action === 'makePublic') {
						this.makePublic();
					} else if (action === 'closeQuestion'){
						this.closeQuestion = true;
					}
				}
			}
		});
	}

	makePublic() {
		const headers: any = {};
		const apiData = {};
		this.popupRef.componentInstance.popupLoader = true;
		this.apiService.makePublic(apiData, this.resourceID, headers).subscribe(
			(response) => {
				this.optionMenu = this.optionMenu.filter(items => items.key !== 'makePublic');
				if (this.popupRef) {
					if (this.popupRef.componentInstance.dialogCloseData) {
						this.popupRef.componentInstance.dialogCloseData.updated = true;
					}
				}
				this.gfService.openSnackBar('SUCCESS', {
					message: this.locale.translate('marked_as_public'),
					icon: 'check_circle_outline',
					position: 'before'
				});
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		)
			.add(() => {
				this.popupRef.componentInstance.popupLoader = false;
			});
	}

	updateResourceStatus(status) {
		this.popupRef.componentInstance.popupLoader = true;
		this.publishButtonDisable = true;
		const headers: any = {};
		let apiData: any = {};
		let method;
		if (this.resourceDetail.resourceTypeID) {
			if (this.resourceDetail.resourceTypeID.key === 'playlist') {
				method = this.apiService.moderatePlaylist(apiData, this.resourceID, status, headers);
			} else if (this.resourceDetail.resourceTypeID.key === 'knowledgeBead') {
				method = this.apiService.moderateKnowledgeBead(apiData, this.resourceID, status, headers);
			} else if (this.resourceDetail.resourceTypeID.key === 'answer') {
				apiData = {
					status
				};
				method = this.apiService.moderateQuestion(apiData, this.resourceID, headers);
			} else if (this.resourceDetail.resourceTypeID.key === 'mooc') {
				method = this.moocApiService.moderate({}, this.resourceID, status, headers);
			} else if (this.resourceDetail.resourceTypeID.key === 'internalEvent') {
				method = this.internalEventApiService.moderate({}, this.resourceID, status, headers);
			} else if (this.resourceDetail.resourceTypeID.key === 'externalEvent') {
				method = this.externalEventApiService.moderate({}, this.resourceID, status, headers);
			} else {
				apiData = {
					status: status,
					resourceID: this.resourceID,
					notificationType: 1
				};
				if (this.deviceDetails.browserName === 'Safari') {
					apiData.notificationType = 2;
				}
				method = this.apiService.moderateResource(apiData, headers);
			}
		}
		method.subscribe(
			(response) => {
				// if (this.popupRef.componentInstance.dialogCloseData) {
				// 	this.popupRef.componentInstance.dialogCloseData.updated = true;
				// }
				let msg = '';
				if (status === 2) {
					if (this.resourceDetail && this.resourceDetail.resourceTypeID && this.resourceDetail.resourceTypeID.key === 'knowledgeBead' && !this.resourceDetail.isMyWorkGroupMember) {
						this.workgroupProcess(true);
					}
					msg = 'resource_published';
				} else if (status === 3) {
					msg = 'resource_un_published';
				}
				this.gfService.openSnackBar('SUCCESS', {
					message: this.locale.translate(msg),
					icon: 'check_circle_outline',
					position: 'before'
				});
				this.reload(true);
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		)
			.add(() => {
				this.popupRef.componentInstance.popupLoader = false;
				this.publishButtonDisable = false;
			});
	}

	workgroupProcess(resourceStatus: boolean = false) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: import('@app/modules/people/people-forms/people-forms.component'),
				componentData: [
					{
						variableName: 'action',
						value: 'workgroupProcess'
					},
					{
						variableName: 'userID',
						value: this.resourceDetail.createdBy
					},
					{
						variableName: 'userData',
						value: {
							name: `${this.resourceDetail.authors[0].firstName}${this.resourceDetail.authors[0].lastName
								? ' ' + this.resourceDetail.authors[0].lastName : ''}`,
							userID: this.resourceDetail.authors[0].userID
						}
					}
				]
			},
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe((result) => {
			if (this.popupRef && this.popupRef.componentInstance.dialogCloseData && resourceStatus) {
				this.popupRef.componentInstance.dialogCloseData.updated = true;
			}
			if (result && typeof result === 'object') {
			}
		});
	}

	deleteResource() {
		this.popupRef.componentInstance.popupLoader = true;
		const headers: any = {};
		const apiData = {
			resourceID: this.resourceDetail.resourceID
		};
		let msg = 'resource_deleted';
		if (['internalEvent', 'externalEvent'].includes(this.resourceDetail.resourceTypeID.key)) {
			msg = 'event_deleted';
		} else if (this.resourceDetail.resourceTypeID.key === 'mooc') {
			msg = 'mooc_deleted';
		}
		this.apiService.deleteResource(apiData, headers).subscribe(
			(response) => {
				this.gfService.openSnackBar('SUCCESS', {
					message: this.locale.translate(msg),
					icon: 'check_circle_outline',
					position: 'before'
				});
				if (this.popupRef) {
					if (this.popupRef.componentInstance.dialogCloseData) {
						this.popupRef.componentInstance.dialogCloseData.updated = true;
					}
					this.popupRef.close(this.popupRef.componentInstance.dialogCloseData);
				}
			},
			(error) => {
				this.gfService.errorHandler(error, {
					snackBar: {
						position: 'before'
					}
				});
			}
		)
			.add(() => {
				this.popupRef.componentInstance.popupLoader = false;
			});
	}

	reject(actionElement) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: ResourceFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'reject'
					},
					{
						variableName: 'resourceDetail',
						value: this.resourceDetail
					}
				],
				triggerEl: actionElement
			},
			disableClose: true,
			maxWidth: '600px'
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result && typeof result === 'object') {
				if (this.popupRef.componentInstance.dialogCloseData) {
					this.popupRef.componentInstance.dialogCloseData.updated = true;
				}
				this.resourceDetail.status = this.baseService.resourceStatus.find(items => items.key === 'rejected');
				this.optionMenu = this.optionMenu.filter(items => items.key !== 'publish');
				if (this.resourceDetail.resourceTypeID.key === 'knowledgeBead') {
					this.workgroupProcess();
				} else {
					this.popupRef.close({ updated: true });
				}
			}
		});
	}

	guideline() {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			data: {
				action: 'dynamic',
				popup: true,
				component: ResourceFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: 'guideline'
					}
				]
			},
			disableClose: true,
			maxWidth: '600px'
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result) {
			}
		});
	}

	addToPlaylist(record, data: any = null) {
		let autoFocus = true;
		if (record.data.key === 'addToPlaylist') {
			autoFocus = false;
		}
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel'],
			autoFocus,
			data: {
				action: 'dynamic',
				popup: true,
				component: PlaylistFormsComponent,
				componentData: [
					{
						variableName: 'action',
						value: record.data.key
					},
					{
						variableName: 'resourceDetail',
						value: data
					}
				],
				triggerEl: record.actionElement
			},
			disableClose: true,
			maxWidth: '860px'
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result && typeof result === 'object') {
				if (record.data.key === 'addToPlaylist' && result.hasOwnProperty('status')) {
					this.addToPlaylist({ data: { key: 'addPlaylist' } });
				}
			}
		});
	}

	rating(data) {
		if (navigator.onLine) {
			// this.featureLoader = true;
			const apiData = {
				notificationType: 1
			};
			if (this.deviceDetails.browserName === 'Safari') {
				apiData.notificationType = 2;
			}
			const headers: any = {};
			this.apiService.addRating(apiData, this.resourceID, data, headers).subscribe(
				(response) => {
					this.baseService.logUserActivity('rating', 'engagement', [''], { resourceData: this.resourceDetail });
					let dialogCloseData;
					if (this.assignmentDetail && this.assignmentDetail.hasOwnProperty('assignmentID')) {
						this.assignmentDetail['avgRating'] = data;
						dialogCloseData = this.assignmentDetail;
					} else {
						this.resourceDetail.avgRating = data;
						dialogCloseData = this.resourceDetail;
					}
					if (this.popupRef) {
						this.popupRef.componentInstance.dialogCloseData = dialogCloseData;
					}
					// this.gfService.openSnackBar('SUCCESS', {
					// 	message: this.locale.translate('resource_rated'),
					// 	icon: 'check_circle_outline',
					// 	position: 'before'
					// });
				},
				(error) => {
					this.gfService.errorHandler(error, {
						snackBar: {
							position: 'before'
						}
					});
				}
			)
				.add(() => {
					// this.featureLoader = false;
				});
		}
	}

	joined(data) {
		if (data.type === 'joined') {
			if (this.resourceDetail.resourceAction.closeQuestion) {
				this.optionMenu.push(
					{
						key: 'closeQuestion',
						caption: this.locale.translate('close_question'),
						classes: [],
						disabled: false
					}
				);
			}
			if (this.resourceDetail.authors && this.resourceDetail.authors.length) {
				this.features.author.count += 1;
			}
		} else if (data.type === 'closed') {
			this.optionMenu = this.optionMenu.filter(items => items.key !== 'closeQuestion');
		}
	}

	reload(event) {
		if (event) {
			// this.resourceLoader = true;
			if (this.popupRef) {
				this.popupRef.componentInstance.popupLoader = true;
			}
			this.resourceDetail.resourceID = null;
			delete this.resourceDetail.resourceTypeID;
			this.getDetail(true);
		}
	}

	embedLink(url) {
		if (navigator.onLine && this.resourceDetail.resourceAction && this.resourceDetail.resourceAction.readLog) {
			this.readExternalLinkLog();
			this.gfService.windowNavigate(url, '_blank');
		}
	}

	segments(segmentData) {
		if (!this.resourceDetail.read && this.resourceDetail.resourceAction && this.resourceDetail.resourceAction.readLog) {
			let storageData: any = this.baseService.processSegmentLog(segmentData, this.resourceID);
			// const resourceSegment = storageData.find(items => items.resourceID === this.resourceID);
			// if (resourceSegment) {
			// 	const percentage = (resourceSegment.segments.length / resourceSegment.totalSegment) * 100;
			// 	if (percentage >= this.appInit.configuration.videoReadPercentage) {
			// 		this.readSegmentLog = false;
			// 		this.addReadLog('segment');
			// 	} else {
			// 		this.readSegmentLog = true;
			// 	}
			// }
			const currentSegmentData = storageData.find(items => items.resourceID === this.resourceID);
			if (currentSegmentData) {
				if (this.playlistParentData && !this.playlistParentData.read && this.playlistData && this.playlistData.length) {
					let count = 0;
					for (const data of this.playlistData) {
						if (data.watched) {
							count += 1;
						}
					}
					const percentage = (count / this.playlistData.length) * 100;
					if (percentage) {
						currentSegmentData.playlistParentPercentage = percentage;
						currentSegmentData.playlistParentID = this.playlistParentData.resourceID;
					}
				}
			}
			localStorage.setItem('segmentData', JSON.stringify(storageData));
			console.log(storageData);

			if (this.resourceDetail.resourceFormat && this.resourceDetail.resourceFormat.key) {
				if (['video', 'audio'].includes(this.resourceDetail.resourceFormat.key) && storageData.length) {
					const findData = storageData.find(items => items.resourceID === this.resourceID);
					if (findData.currentSegment === findData.totalSegment) {
						this.addReadLog('segment', 'general', { cancelable: 'N' });
						localStorage.removeItem('segmentData');
					}
				}
			}
		}
	}

	addReadLog(type: 'time' | 'segment', actionType: 'playlistNavigation' | 'general', additionalHeaderInfo: any = {}) {
		let apiData = {};
		if (type === 'segment') {
			apiData = {
				type: 0
			};
		} else if (type === 'time') {
			apiData = {
				type: 1
			};
		}
		const headers: any = {};
		if (additionalHeaderInfo.cancelable) {
			headers.cancelable = additionalHeaderInfo.cancelable;
		}
		this.apiService.addReadLog(apiData, this.resourceID, headers).subscribe(
			(response) => {
				this.resourceDetail.read = 1;
				this.resourceDetail.completedPercent = 100;
				if (response && this.headerType === 'playlist' && this.playlistData && this.playlistData.length && !this.playlistParentData.read && actionType === 'playlistNavigation') {
					this.playlistData.find(items => {
						if (items.resourceID === response.resourceID) {
							items.watched = true;
							items.changed = true;
							this.playlistData = this.playlistData.slice();
						}
					});
				}
				if (this.CCVAdditionalData) {
					this.CCVAdditionalData.read = 1;
				}
				if (type === 'segment') {
					localStorage.removeItem('segmentData');
				} else if (type === 'time') {
					localStorage.removeItem('timeLogData');
					if (this.timeLogInterval) {
						this.timeLogInterval.clearInterval();
						this.intervalCleared = true;
					}
				}
				if (type === 'time') {
					let editorialTypes = this.baseService.resourceType;
					let editorialKeys = [];
					editorialTypes.forEach((items) => {
						if (items.editorial) {
							editorialKeys.push(items.key);
						}
					});
					if (this.resourceDetail && this.resourceDetail.resourceTypeID && (editorialKeys.includes(this.resourceDetail.resourceTypeID.key) || ['knowledgeBead'].includes(this.resourceDetail.resourceTypeID.key))) {
						this.baseService.logUserActivity('read', 'learning', [''], { resourceData: this.resourceDetail });
					}
				}
			},
			(error) => { }
		).add(() => {
			// this.gfService.blockHttpCall = true;
		});
	}

	addReadSegmentLog(segmentData, actions, type) {
		let apiData: any = {};
		if (segmentData.newSegments) {
			const segments = segmentData.newSegments.map(data => { return Number(data) });
			apiData = {
				segments,
				totalSegments: segmentData.totalSegment,
				lastTimeline: segmentData.currentTime
			};
		} else if (segmentData.hasOwnProperty('currentTime')) {
			apiData = {
				lastTimeline: segmentData.currentTime
			};
		}
		const headers: any = {
			cancelable: 'N'
		};
		// this.gfService.blockHttpCall = false;
		this.apiService.addReadSegmentLog(apiData, this.resourceID, headers).subscribe(
			(response) => {
				if (response && response.read) {
					if (this.headerType === 'playlist' && this.playlistData && this.playlistData.length && !this.playlistParentData.read && type === 'playlistNavigation') {
						this.playlistData.find(items => {
							if (items.resourceID === response.resourceID) {
								items.watched = true;
								items.changed = true;
								this.playlistData = this.playlistData.slice();
							}
						});
					}
					let editorialTypes = this.baseService.resourceType;
					let editorialKeys = [];
					editorialTypes.forEach((items) => {
						if (items.editorial) {
							editorialKeys.push(items.key);
						}
					});
					if (this.resourceDetail && this.resourceDetail.resourceTypeID && (editorialKeys.includes(this.resourceDetail.resourceTypeID.key) || ['knowledgeBead'].includes(this.resourceDetail.resourceTypeID.key))) {
						this.baseService.logUserActivity('read', 'learning', [''], { resourceData: this.resourceDetail });
					}
				}
				localStorage.removeItem('segmentData');
			},
			(error) => { }
		).add(() => {
			if (actions) {
				this.playlistNavigation(actions);
			}
			// this.gfService.blockHttpCall = true;
		});
	}

	addReadTimeLog(timeData, actions, type) {
		let timeSpent = timeData.newTime;
		if (timeData.newTime > timeData.totalDurationInSeconds) {
			timeSpent = timeData.totalDurationInSeconds;
		}
		const apiData = {
			timeSpent,
			totalTime: this.resourceDetail.resource.duration
		};
		const headers: any = { cancelable: 'N' };
		// this.gfService.blockHttpCall = false;
		this.apiService.addReadTimeLog(apiData, this.resourceID, headers).subscribe(
			(response) => {
				localStorage.removeItem('timeLogData');
				if (this.timeLogInterval) {
					this.timeLogInterval.clearInterval();
					this.intervalCleared = true;
				}
				if (response && response.read) {
					if (this.headerType === 'playlist' && this.playlistData && this.playlistData.length && !this.playlistParentData.read && type === 'playlistNavigation') {
						this.playlistData.find(items => {
							if (items.resourceID === response.resourceID) {
								items.watched = true;
								items.changed = true;
								this.playlistData = this.playlistData.slice();
							}
						});
					}
					let editorialTypes = this.baseService.resourceType;
					let editorialKeys = [];
					editorialTypes.forEach((items) => {
						if (items.editorial) {
							editorialKeys.push(items.key);
						}
					});
					if (this.resourceDetail && this.resourceDetail.resourceTypeID && (editorialKeys.includes(this.resourceDetail.resourceTypeID.key) || ['knowledgeBead'].includes(this.resourceDetail.resourceTypeID.key)) && response && response.read) {
						this.baseService.logUserActivity('read', 'learning', [''], { resourceData: this.resourceDetail });
					}
				}
			},
			(error) => { }
		).add(() => {
			if (actions) {
				this.playlistNavigation(actions);
			}
			// this.gfService.blockHttpCall = true;
		});
	}

	updatedTime(time) {
		if (this.resourceDetail && this.resourceDetail.read && this.resourceDetail.resourceAction && this.resourceDetail.resourceAction.readLog) {
			let storageData: any = this.baseService.processSegmentDuration(time, this.resourceID);
			localStorage.setItem('segmentData', JSON.stringify(storageData));
		}
	}

	dialogClose() {
		if (navigator.onLine) {
			// this.gfService.blockHttpCall = false;
			if (this.popupRef) {
				this.popupRef.close(this.popupRef.componentInstance.dialogCloseData || 'close');
			}
			if (this.resourceDetail) {
				this.updateRead(null, 'dialogClose');
			}
		}
	}

	updateRead(actions, type: 'dialogClose' | 'playlistNavigation') {
		let status = false;
		if (!localStorage.getItem('segmentData') && !localStorage.getItem('timeLogData')) {
			status = true;
		}
		let storageData: any = [];
		if (localStorage.getItem('segmentData') && this.readSegmentLog && this.resourceDetail.resourceAction && this.resourceDetail.resourceAction.readLog) {
			storageData = JSON.parse(localStorage.getItem('segmentData'));
			const resourceSegment = storageData.find(items => items.resourceID === this.resourceID);
			if (resourceSegment && ((resourceSegment.newSegments && resourceSegment.newSegments.length) || (!resourceSegment.newSegments && resourceSegment.hasOwnProperty('currentTime')))) {
				if (type === 'playlistNavigation') {
					this.resourceLoader = true;
					this.assignmentLoader = true;
					this.featureLoader = true;
				}
				this.addReadSegmentLog(resourceSegment, actions, type);
			} else {
				status = true;
				localStorage.removeItem('segmentData');
			}
		}
		if (localStorage.getItem('timeLogData') && this.readTimeLog && !this.resourceDetail.read && this.resourceDetail.resourceAction && this.resourceDetail.resourceAction.readLog) {
			storageData = JSON.parse(localStorage.getItem('timeLogData'));
			const resourceTime = storageData.find(items => items.resourceID === this.resourceID);
			if (resourceTime && resourceTime.newTime) {
				if (type === 'playlistNavigation') {
					this.resourceLoader = true;
					this.assignmentLoader = true;
					this.featureLoader = true;
				}
				this.addReadTimeLog(resourceTime, actions, type);
			} else {
				status = true;
				localStorage.removeItem('timeLogData');
				if (this.timeLogInterval) {
					this.timeLogInterval.clearInterval();
					this.intervalCleared = true;
				}
			}
		}
		if (actions && status) {
			this.playlistNavigation(actions);
		}
	}

	loadResource(data) {
		const dialogRef = this.popup.open(PopupComponent, {
			panelClass: ['custom-panel', 'advanced-content'],
			autoFocus: false,
			data: {
				action: 'dynamic',
				popup: true,
				component: ResourceDetailComponent,
				componentData: [
					// {
					// 	variableName: 'type',
					// 	value: (data.createdBy !== this.currentUser.userID) ? 'assign_to_me' : 'assign_by_me'
					// },
					{
						variableName: 'actualResourceID',
						value: data.resourceID
					}
				]
			},
			disableClose: true,
			maxHeight: '100%',
			maxWidth: '100%',
			height: '100%'
		});
		dialogRef.afterClosed().subscribe(async (result) => {
			if (result) {
			}
		});
	}

	ngOnDestroy() {
		if (this.subscriptions) {
			for (const data of this.subscriptions) {
				data.unsubscribe();
			}
		}
		if (this.timeLogInterval) {
			this.timeLogInterval.clearInterval();
			this.intervalCleared = true;
		}
		if (this.youTubeTimeInterval) {
			clearInterval(this.youTubeTimeInterval);
		}

	}
}
